import { Modal } from "bootstrap";
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';; 

export const successToast = (message) => {
    window.store.dispatch('showSuccessModal', message);
};

export const errorToast = (message) => {
    window.store.dispatch('showErrorModal', message);
};

export const helper = {
    showLogin() {
        let login = new Modal('#loginModal');
        login.show();
    },
    openModal(id) {
        setTimeout(() => {
            let modal = new Modal(id);
            modal.show();
        }, 100)
    },
    closeModal(id) {
        setTimeout(() => {
            let closeModal = document.getElementById(id)
            let modal = Modal.getInstance(closeModal);
            if(modal) {
                modal.hide();
            }
        }, 100)
    },
    formatTime(value) {
        return value < 10 ? `0${value}` : value;
    },
    downloadExcel(data, fileName){
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, fileName);
    },
   downloadPdf(data, fileName) {
        const doc = new jsPDF();
        doc.autoTable({
            head: [Object.keys(data[0])],
            body: data.map((obj) => Object.values(obj)),
        });
        doc.save(fileName);
    },
    kFormatter(num) {
        return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)
    },
    notNull(item){
        return item !== ('' || null || undefined)
    },
    compareLength: (len, prop) => {
        return prop.length == len
    },
    testRegex(regex, data) {
        return regex.test(data);
    },
    //----- sanitization helpers
    sanitizeDetails(field, prop, sliceLength) {
        let regexMap = {
            userId: /[^\S]/g,
            password : /[\s]/g,
            login : /\s+/g,
            referCode : /[^0-9]/g,
            oldLoginPassword: /[\s]/g,
            oldLoginUserId: /[\s]/g,
            withdrawPassword: /[\s]/g
        }
        if (regexMap[field]) {
            let sanitizedValue = prop.replace(regexMap[field], '');
            if (sliceLength) {
                sanitizedValue = sanitizedValue.slice(0, sliceLength);
            }
            return sanitizedValue;
        }
        return prop;
    },
    sanitizeNumber(prop, maxValue) {
  prop = prop?.toString() ?? '';

  // Remove non-digits
  let stringValue = prop.replace(/[^0-9]/g, '');

  // If nothing is left, return empty string
  if (stringValue === '') return '';

  // Truncate to 15 digits max
  const truncated = stringValue.slice(0, 15);

  // If maxValue is set and not a giant value, clamp it
  if (maxValue !== 9999999999999999) {
    const num = parseInt(truncated, 10);
    if (isNaN(num)) return '';
    return Math.min(num, maxValue).toString();
  }

  // Else return string directly with leading zeros preserved
  return truncated;
}
,
    getPaginationData(data) {
        return {
            currPage: data.current_page,
            from: data.from,
            to: data.to,
            lastPage: data.last_page,
            perPage: data.per_page,
            total: data.total,
        }
    },
    formatNumber(value) {
        if (value !== null) {
            return parseFloat(value).toFixed(2);
        } else {
            return 0;
        }
    },
    addCommas(value) {
        if (!value) return "0";
        var value = parseFloat(value).toFixed(2);
        value += '';
        var x = value.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        var total = x1 + x2;
        return total;
    },
    positive(val) {
        if (val < 0) {
          return val * -1;
        }
        return val;
    },
    checkDecimalNumber(value) {
        const num = Number(value);
        if (!value || Number.isNaN(num)) return '0';
        return Number.isInteger(num) ? num.toString() : num.toFixed(2);
    },
    
    //----- sanitization helpers,

    scrollToElement(element) {
        setTimeout(() => {
            element.scrollIntoView({ 
                behavior: "smooth", 
                inline: "nearest" 
            });
        }, 200) 
    },
    isMobile() {
        let screenSize = window.innerWidth;
        let mobileView = 991;
        return screenSize<=mobileView
    },
     applySharedComputed(vm, sharedFactory) {
        Object.assign(vm.$options.computed, sharedFactory)
    },
    currencyConverter(convertValue, currency = 1) {
        let currency_rates = {
            1: 1, 
            2: 2, 
            3: 0.01, 
            4: 0.01
        };
        return convertValue && currency_rates[currency] ? currency_rates[currency] * convertValue : convertValue;
    }
}